// Fire-and-forget view tracker for collections & films.
// Server de-dupes per-IP within 30min — safe to call on every mount.
const API_URL = process.env.REACT_APP_BACKEND_URL;

export function trackView(item_type, item_id) {
  if (!item_id) return;
  try {
    // Use sendBeacon if available so it survives page nav
    const body = JSON.stringify({ item_type, item_id });
    const url = `${API_URL}/api/views/track`;
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => { /* silent */ });
  } catch { /* silent */ }
}
